<template>
<div>
	<div class="d-flex flex-row align-items-center justify-content-between">

		<h2>Maintenance Schedule</h2>

		<div v-if="$route.params.slug != 'new'">
			<button class="btn btn-success" v-on:click="newMaintenanceScheduleEvent">
				<i class="fa fa-plus"></i>
				Add Event
			</button>
		</div>
	</div>

	<table-list
		record-name="Maintenance Event"
		:records="mutatedMaintenanceScheduleEvents"
		:fields="[
			{label: 'Event', key: 'title'},
			{label: 'Due Date', key: 'due_date'}
		]"
		:has-edit="true"
		:sortable="true"
		:has-delete="true"
		delete-endpoint="EquipmentMaintenanceEventReminder/delete"
		:hide-record-count="true"
		id-field="slug"
		:other-buttons="[
			{icon: 'fa-wrench',text:'+ Service',click:'createService',class:'btn-light'}
		]"
		v-on:createService="createServiceFromEvent"
		v-on:modelChange="fetchMaintenanceEvents"
		v-on:edit="editMaintenanceScheduleEvent">
	</table-list>

	<modal-dialog :modal-visible="editModal.visible"
		:title="editModal.title"
		:working="editModal.working"
		confirm-button-text="Save"
		:cancel-button-text="editModal.cancelButtonText"
		v-on:closeModal="editModal.visible = false"
		v-on:confirm="saveEntry">

		<field label="Event Type"
			col-class="col-md-4"
			:params="{
				type: 'select',
				options: filteredEventTypeOptions
			}"
			v-model="editModal.payload.event_id">
		</field>

		<field label="Due Date"
			col-class="col-md-4"
			:params="{
				type: 'date',
			}"
			v-model="editModal.payload.due_date">
		</field>

		<template slot="footer">
			<button v-if="editModal.payload.event_id" class="btn btn-dark" type="button" v-on:click="convertToMaintenanceLog">
				Convert to Maintenance Log...
			</button>
		</template>

	</modal-dialog>

	<equipment-maintenance-log-edit-modal :record="logEditModal.record"
		:visible="logEditModal.visible"
		:equipment-item="assetItem"
		:readonly="false"
		:is-customer-asset="true"
		v-on:saved="editModal.cancelButtonText = 'Done'"
		v-on:closeModal="logEditModal.visible = false">
	</equipment-maintenance-log-edit-modal>
</div>
</template>
<script type="text/javascript">

import TableList from "@/components/TableList"
import ModalDialog from "@/components/ModalDialog"
import Field from "@/components/Field"
import EquipmentMaintenanceLogEditModal from "@/components/super_components/EquipmentMaintenanceLogEditModal"

export default {
	name: "AssetMaintenanceScheduleTab",
	components: {
		Field,
		TableList,
		ModalDialog,
		EquipmentMaintenanceLogEditModal
	},
	props: ["assetItem"],
	data() {
		return {
			maintenanceScheduleEvents: [],
			eventTypes: [],
			eventTypeCategories: [],
			openRecordOnLoad: false,
			editModal: {
				visible: false,
				title: "New Maintenance Schedule Entry",
				payload: {},
				working: false,
				cancelButtonText: "Cancel"
			},
			logEditModal: {
				visible: false,
				record: null
			}
		}
	},
	watch: {
		assetItem() {
			if (this.assetItem && "id" in this.assetItem) {
				this.fetchMaintenanceEvents()

				if ("tabRecordSlug" in this.$route.params && this.$route.params.tab == 'maintenance-schedule')
					this.openRecordOnLoad = this.$route.params.tabRecordSlug
			}
		}
	},
	computed: {
		mutatedMaintenanceScheduleEvents() {
			let vm = this

			return this.maintenanceScheduleEvents.map(event => {
				event.title = event.EquipmentMaintenanceEventType.title

				return event
			})
		},
		filteredEventTypeOptions() {
			return this.optionify(this.eventTypes.filter(eventType => {
				if (eventType.EquipmentType.find(type => type.id == this.assetItem.type_id))
					return true
				else if (!eventType.EquipmentType || eventType.EquipmentType.length == 0)
					return true
			}),"title")
		}
	},
	methods: {
		newMaintenanceScheduleEvent() {
			this.editModal.visible = true
			this.editModal.title = "New Maintenance Schedule Entry"
			this.editModal.cancelButtonText = "Cancel"
			this.editModal.payload = {
				due_date: null,
				event_id: null,
				asset_id: this.assetItem.id
			}

			if (this.eventTypes.length == 0)
				this.fetchEventTypes()
		},
		editMaintenanceScheduleEvent(record) {
			this.editModal.visible = true
			this.editModal.title = "Edit Maintenance Schedule Entry"
			this.editModal.cancelButtonText = "Cancel"
			this.editModal.payload = {
				due_date: record.due_date,
				event_id: record.event_id,
				id: record.id,
				asset_id: this.assetItem.id
			}

			if (this.eventTypes.length == 0)
				this.fetchEventTypes()
		},
		saveEntry() {
			let vm = this

			this.editModal.working = true

			this.postData("EquipmentMaintenanceEventReminder/save",this.editModal.payload,true).then(response => {
				this.editModal.working = false

				if (response.success) {
					vm.fetchMaintenanceEvents()
					vm.editModal.visible = false
				}
			})
		},
		convertToMaintenanceLog() {
			let eventType = this.eventTypes.find(eventType => eventType.id == this.editModal.payload.event_id)

			let workDone = ""
			if (eventType) {
				workDone = "Completed " + eventType.title

				if (eventType.description)
					workDone += ": " + eventType.description
			}

			let populatedRecord = {
				equipment_slug: this.assetItem.slug,
				date_done: this.moment().format("YYYY-MM-DD"),
				work_done: workDone,
				EquipmentMaintenanceEventType: [this.editModal.payload.event_id],

			}

			let category = this.eventTypeCategories.find(cat => cat.id == eventType.category_id)
			if (category) 
				populatedRecord.type = category.name

			this.logEditModal.visible = true
			this.logEditModal.record = populatedRecord

		},
		createServiceFromEvent(item) {
			
			let vm = this

			this.$router.push("/service/new/details/details").then(response => {
				vm.$store.service.customer_id = item.CustomerAsset.contact_id
				vm.$store.service.is_emergency = 0
				vm.$store.service.description = item.title + " on Asset " + item.CustomerAsset.description + " (SN " + item.CustomerAsset.serial_num + ")"
			})	
		},
		fetchEventTypes() {
			let vm = this

			this.getJSON("EquipmentMaintenanceEventType/get",{include: [{model: "EquipmentType",fields:["id","slug"]}]}).then(response => {
				if (response.success)
					vm.eventTypes = response.data
			})

			this.getJSON("EquipmentMaintenanceEventType/categories").then(response => {
				if (response.success)
					vm.eventTypeCategories = response.data
			})
		},
		fetchMaintenanceEvents() {
			let vm = this

			let params = {
				filters: [
					["asset_id",this.assetItem.id]
				],
				include: [
					{
						model: "EquipmentMaintenanceEventType",
						fields: ["title"]
					},
					{
						model: "CustomerAsset",
						fields: ["description","serial_num","contact_id"]
					}
				]
			}

			this.getJSON("EquipmentMaintenanceEventReminder/get",params).then(response => {
				if (response.success) {
					vm.maintenanceScheduleEvents = response.data

					if (vm.openRecordOnLoad) {
						let recordToOpen = vm.maintenanceScheduleEvents.find(event => event.slug == vm.openRecordOnLoad)
						vm.editMaintenanceScheduleEvent(recordToOpen)
						vm.openRecordOnLoad = false
					}
				}
			})
		}
	},
	created() {
		if (this.assetItem && "id" in this.assetItem)  {
			this.fetchMaintenanceEvents()

			if ("tabRecordSlug" in this.$route.params && this.$route.params.tab == 'maintenance-schedule')
				this.openRecordOnLoad = this.$route.params.tabRecordSlug
		}
	}
}
</script>